import { Component, HostListener, OnInit, inject } from '@angular/core';
import { FirestoreService } from '@services/firestore/firestore.service';
import { IAumentoPgu } from '@interfaces/reforma-configuraciones-texto.interface';
@Component({
    selector: 'app-aumento-pgu',
    templateUrl: './aumento-pgu.component.html',
    styleUrl: './aumento-pgu.component.scss',
    standalone: false
})
export class AumentoPguComponent implements OnInit {

  private readonly firestoreService = inject(FirestoreService);

  isVersionMobile: boolean = false;

  content$ = this.firestoreService
    .getDoc<{ 'Conoce-mas-sobre-la-reforma': { beneficios: { 'aumento-pgu': IAumentoPgu } } }>(
      'reforma-pensiones',
      'configuraciones-texto'
    );

  ngOnInit() {
    this.isVersionMobile = window.innerWidth < 1140;
  }

  @HostListener("window:resize")
  onWindowResize() {
    this.isVersionMobile = window.innerWidth < 1140;
  }

}